import { render, staticRenderFns } from "./ConversationContactPane.vue?vue&type=template&id=272d4f6e&scoped=true"
import script from "./ConversationContactPane.vue?vue&type=script&lang=js"
export * from "./ConversationContactPane.vue?vue&type=script&lang=js"
import style0 from "./ConversationContactPane.vue?vue&type=style&index=0&id=272d4f6e&prod&lang=scss&scoped=true"
import style1 from "./ConversationContactPane.vue?vue&type=style&index=1&id=272d4f6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d4f6e",
  null
  
)

export default component.exports